import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';

import TemplateType from 'types/TemplateType';
import { ChangeEvent } from 'utils/ui';

interface TemplateTypePickerProps {
  value: TemplateType | null;
  onChange: (e: ChangeEvent) => void;
}

const TemplateTypePicker: React.FC<TemplateTypePickerProps> = ({ value, onChange }) => {
  const templateTypes = Object.values(TemplateType) as string[];

  return (
    <FormControl fullWidth>
      <TextField value={value || ''} onChange={onChange} select label="Template Type">
        {templateTypes.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
};

export default TemplateTypePicker;
